import React, { useEffect, useState } from "react";
import { Card, CardContent, Grid, Typography, Avatar, Box, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, } from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { procurementKpiMapper } from "./mapper";
import TitleBar from "components/TitleBar";
import AssetError from "./AssetError";
import { useLazyGetAllDependenciesQuery } from "store/slices/apis/customerDependenciesSlice";
import { DEFAULT_DATE_FORMAT } from "config";
import moment from "moment/moment";


const dependencies = [
    { id: 1, task: "Finalization of entry and exit gate positions by Safexpress" },
    { id: 2, task: "Demarkation of truck docking levels as per heights shall be marked on architectural plan" },
    { id: 3, task: "Internal warehouse electrical layout" },
    { id: 4, task: "Racking Layout" },
    { id: 5, task: "DG Capacity" },
    { id: 6, task: "Office electrical layout" },
    { id: 7, task: "Staff quarters layout" },
    { id: 8, task: "Labour quarters layout" },
    { id: 9, task: "Guard Room Layout" },
    { id: 10, task: "Office space location inside shed" },
    { id: 11, task: "Pantry & Toilet layout" },
    { id: 12, task: "Aluminium external windows sizes & color" },
    { id: 13, task: "Labour washroom layout" },
    { id: 14, task: "Color palette for the rolling shutters and PEB Structure" },
    { id: 15, task: "Wall cladding sheets color shade approval" },
];

const Dependencies = ({ data, isLoading, error, assetError }) => {

    const [filters, setFilters] = useState({
        // ProjectId: projectId,
        SortBy: 'desc',
        SortOrder: 'CreatedDate',
    });

    const [trigger, { data: workflowList, isFetching }] = useLazyGetAllDependenciesQuery();

    useEffect(() => {
        trigger(filters);
    }, []);

    // const { projectId } = useParams();
    if (assetError) {
        return <AssetError />
    }

    if (isLoading) {
        return <Box sx={{
            background: "#fff",
            borderRadius: "8px",
            p: 4,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
            border: "1px solid #E4E4E4",
            textAlign: "center"
        }}>
            <div>Loading KPIs...</div>
        </Box>;
    }



    if (error) {

        console.error("Failed to fetch KPI metrics:", error);
        return (
            <Box sx={{
                background: "#fff",
                borderRadius: "8px",
                p: 4,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E4E4E4",
                textAlign: "center"
            }}>
                <div style={{ color: 'red' }}>
                    Error loading data: {error.status} - {error.data?.message || "Please try again."}
                </div>
            </Box>

        );
    }

    if (!data) {
        return null;
    }

    // const kpis = procurementKpiMapper(data?.data || {});


    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 3,
                border: "1px solid #eef0f4",
                // p: "20px 17px 20px 34px",
                //maxHeight: { xs: "auto", md: "316px" }
                height: "100%",
                boxSizing: "border-box"
            }}
        >
            <Grid container>
                <TitleBar
                    title="Dependencies"
                    description="Dependencies on Safexpress"
                />
            </Grid>
            {/* <Typography sx={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: '20px',
                lineHeight: '32px',
                letterSpacing: "0px",
                color: "#05004E",

            }}>
                Design And Engineering
            </Typography>
            <Typography sx={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '30px',
                letterSpacing: "0px",
                color: "#737791",
                mb: 2
            }}>
                Tracks design progress to ensure efficiency and on-time project completion.
            </Typography> */}

            <Grid container spacing={1} sx={{ p: 0 }}>
                <TableContainer component={Paper} sx={{
                    maxHeight: 250,
                    overflow: 'auto',
                    '&::-webkit-scrollbar': { width: '8px' },
                    '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '4px' }
                }}>
                    <Table stickyHeader aria-label="dependencies table" size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#fafafa' }}>
                                <TableCell sx={{ fontWeight: 'bold' }}>Sl. No.</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Dependencies on Safexpress</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Due Date</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Target Date</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Received Date</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Remarks</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {workflowList?.data?.map((row, index) => (
                                <TableRow key={row.id} hover>
                                    <TableCell sx={{ fontWeight: 'bold' }}>{index + 1}</TableCell>
                                    <TableCell>{row.dependencyOnSafeExpress}</TableCell>
                                    <TableCell>{row.status}</TableCell>
                                    <TableCell>{row?.dueDate ?
                                        moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)
                                        : ''
                                    }</TableCell>
                                    <TableCell>{row?.targetDate ?
                                        moment(row?.targetDate).format(DEFAULT_DATE_FORMAT)
                                        : ''
                                    }</TableCell>
                                    <TableCell> {row?.receivedDate ?
                                        moment(row?.receivedDate).format(DEFAULT_DATE_FORMAT)
                                        : ''
                                    }</TableCell>
                                    <TableCell>{row?.remarks}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Card>
    );
};

export default Dependencies;
